import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { ContactBlock } from "../components/SocialLinks";
import AppleSignInButton from "../components/AppleSignInButton";
import GoogleIcon from "../components/GoogleIcon";


export default function Login() {
  const { user, login, googleLogin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) {
    if (user.must_change_password) return <Navigate to="/first-login" replace />;
    return <Navigate to="/workspaces" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(email, password);
      if (u?.must_change_password) nav("/first-login");
      else nav("/spaces");
    }
    catch (e) { setErr(e?.response?.data?.detail || "Sign in failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="m-auth-page">
      <div className="m-auth-aside">
        <div className="m-auth-logo-wrap">
          <img src="/brand/metier-logo-gold.png" alt="Métier" />
        </div>
        <div>
          <h1 className="m-auth-heading">Work <em>Anywhere</em>.<br/>Connect <em>Everywhere</em>.</h1>
          <p className="m-auth-lede">Workspaces, Métier Hours café perks, and a community built for the way you work today.</p>
        </div>
        {/* Session 60.10 · Contact + social block on the visitor login page.
            Uses the dark variant so it reads on the navy aside without
            reintroducing a bright card. */}
        <ContactBlock variant="dark" />
        <div className="m-auth-foot-aside">
          <span>workmetier.com</span>
        </div>
      </div>
      <div className="m-auth-main">
        <div className="m-auth-card">
          <span className="m-eyebrow">Sign in</span>
          <h2 className="m-auth-h2">Welcome <em>back</em>.</h2>
          <p className="m-auth-sub">Continue with Apple, Google, or your member credentials.</p>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <AppleSignInButton testid="apple-login-btn" onError={(m) => setErr(m)} />
            <button type="button" className="m-google-btn" onClick={googleLogin} data-testid="google-login-btn">
              <GoogleIcon /> <span>Continue with Google</span>
            </button>
          </div>

          <div className="m-divider"><span>or with email</span></div>

          <form onSubmit={onSubmit} className="m-form">
            <label className="m-field">
              <span>Email</span>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" data-testid="login-email" />
            </label>
            <label className="m-field">
              <span>Password</span>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="login-password" />
            </label>
            <div className="m-form-forgot">
              <Link to="/forgot-password" data-testid="link-forgot-password">Forgot password?</Link>
            </div>
            {err && <div className="m-form-err" data-testid="login-error">{err}</div>}
            <button type="submit" className="m-btn-gold" disabled={busy} data-testid="login-submit">
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>

          <p className="m-auth-foot">New to Métier? <Link to="/signup" data-testid="link-signup">Join network →</Link></p>
        </div>
      </div>
    </div>
  );
}
